"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSearch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const clsx_1 = require("clsx");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const LoadingSpinner_1 = require("Views/Shared/Components/LoadingSpinner/LoadingSpinner");
const context_1 = require("../../context");
const DocumentSearch = () => {
    const { query, resultCount, refineQuery, clearQuery, dictionary, isHitsLoading, setIsHitsLoading, } = (0, context_1.useSearchResultContext)();
    const inputRef = React.useRef(null);
    const [typedSearchValue, setTypedSearchValue] = React.useState(query === '*' ? '' : query);
    const [prevQuery, setPrevQuery] = React.useState(query);
    const [isLoadingSearch, setIsLoadingSearch] = React.useState(false);
    React.useEffect(() => {
        if (isHitsLoading === false) {
            setIsLoadingSearch(false);
        }
    }, [isHitsLoading]);
    const handleSearch = () => {
        if (prevQuery === typedSearchValue) {
            return;
        }
        if (typedSearchValue || (query && typedSearchValue === '')) {
            setIsHitsLoading(true);
            setIsLoadingSearch(true);
            refineQuery(typedSearchValue);
        }
        setPrevQuery(typedSearchValue);
    };
    const onInputChange = (event) => {
        setTypedSearchValue(event.target.value);
    };
    const onInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    const onSearchIconClick = () => {
        handleSearch();
    };
    const onSearchClearIconClick = () => {
        var _a;
        setTypedSearchValue('');
        setIsHitsLoading(true);
        setIsLoadingSearch(true);
        clearQuery();
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-end justify-between flex-wrap mb-4 sm:mb-8", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-search-input-border-radius relative border-primary focus-within:border-primary-pressed bg-fill-primary border-sm md:focus-within:focus-outline flex items-center min-w-full md:min-w-[300px] pr-4xl", children: [(0, jsx_runtime_1.jsx)("button", { "aria-label": dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchButton, onClick: onSearchIconClick, type: "button", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "search", className: (0, clsx_1.clsx)('df-icon text-primary p-xs', isHitsLoading && isLoadingSearch && 'opacity-35') }) }), (0, jsx_runtime_1.jsx)("input", { className: (0, clsx_1.clsx)('flex-1 bg-surface-primary text-primary h-[42px] w-full border-0 px-1.5 outline-0', isHitsLoading && isLoadingSearch && 'opacity-35'), type: "search", disabled: isHitsLoading && isLoadingSearch, "aria-label": dictionary === null || dictionary === void 0 ? void 0 : dictionary.search, value: typedSearchValue, placeholder: dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchInResultsPlaceholder, onChange: onInputChange, onKeyDown: onInputKeyDown, ref: inputRef }), !isHitsLoading && !isLoadingSearch && (typedSearchValue === null || typedSearchValue === void 0 ? void 0 : typedSearchValue.length) > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "absolute right-0 pr-4xs flex h-full items-center", children: (0, jsx_runtime_1.jsx)("button", { className: "text-secondary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed p-2xs rounded-full focus:outline-offset-0", type: "button", onClick: onSearchClearIconClick, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "cancel-outline", className: "df-icon icon-md" }) }) })), isHitsLoading && isLoadingSearch && ((0, jsx_runtime_1.jsx)("div", { className: "absolute right-0 pr-4xs flex h-full items-center", children: (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { visible: true }) }))] }), (0, jsx_runtime_1.jsxs)("span", { className: "mt-4 md:mt-0 md:px-4 body-md text-primary whitespace-nowrap", children: [dictionary === null || dictionary === void 0 ? void 0 : dictionary.numberOfItems, " (", resultCount || 0, ")"] })] }));
};
exports.DocumentSearch = DocumentSearch;
